// return the partner api URL
export function partnerApi() {
  // development
  if(
    typeof window === 'undefined'
    || window.location.hostname.includes('lflgroup.io')
    || window.location.hostname.includes('azurestaticapps.net')
    || ['10.0.0.110', 'localhost'].includes(window.location.hostname)
  ) {
    return 'https://tgi-partner.api.lflgroup.io'
  }
  // production
  return 'https://tgi-partner.api.lflgroup.ca'
}

// return the partner api URL
export function addressApi() {
  // development
  if(
    typeof window === 'undefined'
    || window.location.hostname.includes('lflgroup.io')
    || window.location.hostname.includes('azurestaticapps.net')
    || ['10.0.0.110', 'localhost'].includes(window.location.hostname)
  ) {
    return 'https://address.api.lflgroup.io'
  }
  // production
  return 'https://address.api.lflgroup.ca'
}

